<template>
  <StepTemplate
    class="StepService"
    :error="error"
    stepName="stepService"
    bottomBtn
    :disabledBtn="!hasOneServiceActive"
    @nextStep="$emit('nextStep', 3)"
  >
    <v-row class="d-flex justify-center">
      <v-col v-for="service in services" :key="service.key" cols="12" md="5" lg="4" xl="2">
        <CardService :service="service" />
      </v-col>
    </v-row>
  </StepTemplate>
</template>

<script>
import StepTemplate from '@/components/onboarding/UI/StepTemplate'
import CardService from '@/components/onboarding/UI/CardService'

export default {
  name: 'StepService',
  components: { StepTemplate, CardService },
  props: {
    error: {
      type: String
    },
    services: {
      type: Array,
      required: true
    }
  },
  computed: {
    hasOneServiceActive() {
      let submitable = false
      for (let service in this.services) {
        this.services[service].active && (submitable = true)
      }
      return submitable
    }
  }
}
</script>

<style scoped lang="scss"></style>
